import { getCurrentIdReduxSelector } from '../../../../redux/selectors/get-current-id'
import WORKOUTS_PATH from '../../constants/path'

const getStartedIdWorkoutSelect = (state) => getCurrentIdReduxSelector(
  WORKOUTS_PATH.DATA,
  WORKOUTS_PATH.STARTED
)(
  state)

export { getStartedIdWorkoutSelect }
